module.exports = __webpack_public_path__ + "img/trustwallet.46c67394.png";